import React from 'react'
import { view } from 'react-easy-state'
import { Icon } from 'antd'

import VideoPlayer from 'components/common/VideoPlayer'
import { API, getAuthorization, createUrl } from "api"
import axios from "axios"

class VideoView extends React.Component {
  constructor(props) {
    super(props)
    this.currentPlayer = null;
    this.videoId = null;
    this.chapterId = null;
  }

  videoTracking(currentTime, chapterId, videoId) {
    console.log(chapterId, videoId);
    const formData = new FormData();
    formData.append("time", currentTime);
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/${createUrl(API.students.videos.track.url, { chapterId, videoId })}`, formData, {
        headers: {
          Authorization: getAuthorization(),
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        const responseData = response.data
        console.log(responseData)
      })
      .catch((e) => {
        console.error("Error", e)
        this.setState({
          submitting: false,
        })
      })
  }

  componentWillUnmount() {
    console.log("component will unmount")
    this.videoTracking(
      this.currentPlayer?.currentTime,
      this.chapterId,
      this.videoId,
    )
  }

  playerReady(player, context) {
    // player.on('timeupdate', event  => {
    //   console.log(parseInt(player.currentTime), chapterId, videoId);
    // });
    const { video, chapterId } = context.props;
    context.currentPlayer = player;
    context.videoId = video.id;
    context.chapterId = chapterId;
    
    player.on('play', event  => {
      context.videoTracking(parseInt(player.currentTime), chapterId, video.id);
    });

    player.on('pause', event  => {
      context.videoTracking(parseInt(player.currentTime), chapterId, video.id);
    });
  }

  render() {

    const { video } = this.props;
    console.log(video.provider);

    const videoPlayerOptions = {
      autoplay: false,
      controls: [
        'play-large',
        'play',
        'progress',
        'duration',
        'volume',
        'settings',
        'pip',
        'fullscreen',
      ],
      playsinline: true,
      html5: {
        hlsjsConfig: {
          debug: true
        }
      },
      onPlayerReady: this.playerReady,
      context: this,
      sources: []
    }

    if (video.provider === "learner_m3u8") {
      videoPlayerOptions.sources[0] = {
        src: video.url,
        type: 'application/vnd.apple.mpegURL',
        overrideNative: true,
      }
    } else {
      videoPlayerOptions.sources[0] = {
        src: video.url,
        provider: video.provider
      }
    }

    return (
      <div className="lecture-video-view">
        <div className="header"><Icon type="youtube" /> <h2>{video.name}</h2></div>
        <div className="lecture-video-content" style={{ padding: '30px 0px' }}>
          <div data-vjs-player>
            <VideoPlayer {...videoPlayerOptions} />
            {/* <iframe title={video.name} width="560" height="315" src={videoUrl} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe> */}
          </div>
        </div>
      </div>
    )
  }
}

export default view(VideoView)
